/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Manage_Revenue_AccountsInputs */

const en_admin_resource_form_manage_revenue_accounts = /** @type {(inputs: Admin_Resource_Form_Manage_Revenue_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage revenue accounts`)
};

const de_admin_resource_form_manage_revenue_accounts = /** @type {(inputs: Admin_Resource_Form_Manage_Revenue_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlöskonten verwalten`)
};

const es_admin_resource_form_manage_revenue_accounts = /** @type {(inputs: Admin_Resource_Form_Manage_Revenue_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar las cuentas de ingresos`)
};

const fr_admin_resource_form_manage_revenue_accounts = /** @type {(inputs: Admin_Resource_Form_Manage_Revenue_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les comptes de recettes`)
};

const nl_admin_resource_form_manage_revenue_accounts = /** @type {(inputs: Admin_Resource_Form_Manage_Revenue_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omzetrekeningen beheren`)
};

/** @type {(inputs: Admin_Resource_Form_Manage_Revenue_AccountsInputs) => LocalizedString} */
const it_admin_resource_form_manage_revenue_accounts = en_admin_resource_form_manage_revenue_accounts;

/** @type {(inputs: Admin_Resource_Form_Manage_Revenue_AccountsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_manage_revenue_accounts = en_admin_resource_form_manage_revenue_accounts;

/** @type {(inputs: Admin_Resource_Form_Manage_Revenue_AccountsInputs) => LocalizedString} */
const pl_admin_resource_form_manage_revenue_accounts = en_admin_resource_form_manage_revenue_accounts;

/** @type {(inputs: Admin_Resource_Form_Manage_Revenue_AccountsInputs) => LocalizedString} */
const hu_admin_resource_form_manage_revenue_accounts = en_admin_resource_form_manage_revenue_accounts;

/** @type {(inputs: Admin_Resource_Form_Manage_Revenue_AccountsInputs) => LocalizedString} */
const ro_admin_resource_form_manage_revenue_accounts = en_admin_resource_form_manage_revenue_accounts;

/**
* | output |
* | --- |
* | "Manage revenue accounts" |
*
* @param {Admin_Resource_Form_Manage_Revenue_AccountsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_manage_revenue_accounts = /** @type {((inputs?: Admin_Resource_Form_Manage_Revenue_AccountsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Manage_Revenue_AccountsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_manage_revenue_accounts(inputs)
	if (locale === "de") return de_admin_resource_form_manage_revenue_accounts(inputs)
	if (locale === "es") return es_admin_resource_form_manage_revenue_accounts(inputs)
	if (locale === "fr") return fr_admin_resource_form_manage_revenue_accounts(inputs)
	if (locale === "nl") return nl_admin_resource_form_manage_revenue_accounts(inputs)
	if (locale === "it") return it_admin_resource_form_manage_revenue_accounts(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_manage_revenue_accounts(inputs)
	if (locale === "pl") return pl_admin_resource_form_manage_revenue_accounts(inputs)
	if (locale === "hu") return hu_admin_resource_form_manage_revenue_accounts(inputs)
	return ro_admin_resource_form_manage_revenue_accounts(inputs)
});
export { admin_resource_form_manage_revenue_accounts as "admin.resource_form.manage_revenue_accounts" }